// login action

import { sendNewPaymentEventToGTM } from '../../services/googleTagManager'
import * as DotGQL from '../../services/graphQL'
import { NOTIFICATIONS } from '../../util/notification'
import {
  ADD_ASSIGNABLE_USERS_SUCCESS,
  EDIT_USER_SUCCESS,
  GETTING_ACCESSED_USERS_FAILURE,
  GETTING_ACCESSED_USERS_SUCCESS,
  GETTING_ASSIGNABLE_USERS_FAILURE,
  GETTING_ASSIGNABLE_USERS_SUCCESS,
  REVOKE_USERS_ACCESS_SUCCESS,
  SETTING_USER_SUCCESS
} from '../actionTypes'
import { loadingStart, loadingStop, notificationFail, notificationSuccess } from './customization'

export const settingUser = (client: any) => {
  return (dispatch: any) => {
    dispatch(loadingStart())
    client
      .query({
        query: DotGQL.queryUserDetails,
        fetchPolicy: 'no-cache'
      })
      .then((response: any) => {
        dispatch(loadingStop())
        dispatch({
          type: SETTING_USER_SUCCESS,
          data: response?.data?.userDetails
        })
      })
      .catch((error: any) => {
        dispatch(loadingStop())
        dispatch(notificationFail(error, error.message))
      })
  }
}

export const getUserDetailSendGtmTrigger = (client: any) => {
  return (dispatch: any) => {
    client
      .query({
        query: DotGQL.queryUserDetails,
        fetchPolicy: 'no-cache'
      })
      .then((response: any) => {
        dispatch({
          type: SETTING_USER_SUCCESS,
          data: response?.data?.userDetails
        })
        let data = {
          userEmail: response?.data?.userDetails?.email
        }
        sendNewPaymentEventToGTM(data)
      })
      .catch((error: any) => {
        dispatch(notificationFail(error, error.message))
      })
  }
}

export const getAssignableUser = (client: any, req?: any) => {
  return (dispatch: any) => {
    client
      .query({
        query: DotGQL.queryAssignableUserList,
        fetchPolicy: 'no-cache',
        variables: req
      })
      .then((response: any) => {
        dispatch(loadingStop())
        dispatch({
          type: GETTING_ASSIGNABLE_USERS_SUCCESS,
          data: response?.data?.assignableUserList
        })
      })
      .catch((error: any) => {
        dispatch({
          type: GETTING_ASSIGNABLE_USERS_FAILURE,
          payload: error
        })
        dispatch(notificationFail(error, error.message))
      })
  }
}

export const getAccessedUserList = (client: any, req?: any) => {
  return (dispatch: any) => {
    dispatch(loadingStart())
    client
      .query({
        query: DotGQL.queryAccessUserList,
        fetchPolicy: 'no-cache',
        variables: req
      })
      .then((response: any) => {
        dispatch(loadingStop())
        dispatch({
          type: GETTING_ACCESSED_USERS_SUCCESS,
          data: response?.data?.accessUserList
        })
      })
      .catch((error: any) => {
        dispatch({
          type: GETTING_ACCESSED_USERS_FAILURE,
          payload: error
        })
        dispatch(loadingStop())
        dispatch(notificationFail(error, error.message))
      })
  }
}

export const addAssignUsers = (client: any, req: any, callBack: any) => {
  return (dispatch: any) => {
    dispatch(loadingStart())
    client
      .mutate({
        mutation: DotGQL.mutationAssignUsers,
        fetchPolicy: 'no-cache',
        variables: req
      })
      .then((response: any) => {
        dispatch(loadingStop())
        dispatch(notificationSuccess(NOTIFICATIONS.SUCCESS.assignUsersSuccess))
        dispatch({
          type: ADD_ASSIGNABLE_USERS_SUCCESS,
          data: response?.data
        })
        callBack()
      })
      .catch((error: any) => {
        dispatch(loadingStop())
        dispatch(notificationFail(NOTIFICATIONS.ERROR.assignUsersFail, error.message))
      })
  }
}

export const revokeUserAccess = (client: any, req: any, callBack: any) => {
  return (dispatch: any) => {
    dispatch(loadingStart())
    client
      .query({
        query: DotGQL.mutationRevokeUsers,
        fetchPolicy: 'no-cache',
        variables: req
      })
      .then((value: any) => {
        dispatch({
          type: REVOKE_USERS_ACCESS_SUCCESS
        })
        dispatch(notificationSuccess(NOTIFICATIONS.SUCCESS.revokeUserAccessSuccess))
        dispatch(loadingStop())
        callBack()
      })
      .catch((error: any) => {
        dispatch(loadingStop())
        dispatch(notificationFail(NOTIFICATIONS.ERROR.revokeUserAccessFail))
      })
  }
}

export const editUser = (client: any, req: any) => {
  return (dispatch: any) => {
    dispatch(loadingStart())
    client
      .mutate({
        mutation: DotGQL.queryUpdate,
        fetchPolicy: 'no-cache',
        variables: { ...req }
      })
      .then((response: any) => {
        dispatch(loadingStop())
        dispatch(notificationSuccess(NOTIFICATIONS.SUCCESS.editUserSuccess))
        dispatch({
          type: EDIT_USER_SUCCESS,
          data: response?.data?.editProfile
        })
      })
      .catch((error: any) => {
        dispatch(loadingStop())
        dispatch(notificationFail(NOTIFICATIONS.ERROR.addNewUserFail, error.message))
      })
  }
}

export const editUserWithoutNotification = (client: any, req: any) => {
  return (dispatch: any) => {
    // dispatch(loadingStart())
    client
      .mutate({
        mutation: DotGQL.queryUpdate,
        fetchPolicy: 'no-cache',
        variables: { ...req }
      })
      .then((response: any) => {
        // dispatch(loadingStop())
        // dispatch(notificationSuccess(NOTIFICATIONS.SUCCESS.editUserSuccess))
        dispatch({
          type: EDIT_USER_SUCCESS,
          data: response?.data?.editProfile
        })
      })
      .catch((error: any) => {
        dispatch(loadingStop())
        // dispatch(notificationFail(NOTIFICATIONS.ERROR.addNewUserFail, error.message))
      })
  }
}

export const editUserAccount = (client: any, req: any) => {
  return (dispatch: any) => {
    dispatch(loadingStart())
    client
      .mutate({
        mutation: DotGQL.queryUpdate,
        fetchPolicy: 'no-cache',
        variables: { ...req }
      })
      .then((response: any) => {
        dispatch(loadingStop())
        dispatch(notificationSuccess(NOTIFICATIONS.SUCCESS.editUserSuccess))
      })
      .catch((error: any) => {
        dispatch(loadingStop())
        dispatch(notificationFail(NOTIFICATIONS.ERROR.addNewUserFail, error.message))
      })
  }
}